import { useHistory, useLocation } from 'react-router-dom';

type UseLocationParamResult = [param: string, updateFn: (newHash: string) => void];

const useLocationParam = (type: 'hash' | 'search'): UseLocationParamResult => {
  const { hash, search } = useLocation();
  const history = useHistory();
  const param = type === 'hash' ? hash : search;

  const update = (newParam: string) => {
    // eslint-disable-next-line security/detect-possible-timing-attacks
    if (newParam !== param) {
      history.replace({ [type === 'hash' ? 'hash' : 'search']: newParam });
    }
  };

  return [param, update];
};

export const useLocationHash = (): UseLocationParamResult => useLocationParam('hash');
export const useLocationSearch = (): UseLocationParamResult => useLocationParam('search');
